import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import QRResolver from './components/QRResolver';
import MenuRenderer from './components/MenuRenderer';
import SingleMenuRenderer from './components/SingleMenuRenderer';
import DemoDashboard from './pages/DemoDashboard';
import TemplateThumbnailPage from './pages/TemplateThumbnailPage';
import NotFound from './pages/NotFound';
import './App.css';
import ImageDisclaimer from './components/ImageDisclaimer';

function App() {
  const enableThumbRoute = process.env.REACT_APP_ENABLE_THUMB_ROUTE === 'true';

  // Global cache-bust on manual reload: append _cb once to force fresh HTML/assets
  React.useEffect(() => {
    try {
      let navType = '';
      if (window.performance && typeof window.performance.getEntriesByType === 'function') {
        const nav = window.performance.getEntriesByType('navigation');
        if (nav && nav.length > 0) navType = nav[0].type;
      } else if (window.performance && window.performance.navigation && window.performance.navigation.type === 1) {
        navType = 'reload';
      }

      if (navType === 'reload') {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('_cb')) {
          url.searchParams.set('_cb', Date.now().toString());
          window.location.replace(url.toString());
        }
      }
    } catch (e) {
      // ignore
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <ImageDisclaimer />
        <Routes>
          {/* Landing / Demo Dashboard */}
          <Route path="/" element={<DemoDashboard />} />

          {/* Main QR Entry Point */}
          <Route path="/r/:shortcode" element={<QRResolver />} />

          {/* Preview / direct template entry: example -> /p/ABC123?templateName=Modern%20Chic */}
          <Route path="/p/:shortcode" element={<MenuRenderer />} />

          {/* Single Menu Card View */}
          <Route path="/d/:shortcode/menu/:menuId" element={<SingleMenuRenderer />} />

          {/* Internal thumbnail renderer used by the generator script only */}
          {enableThumbRoute && (
            <Route path="/thumb" element={<TemplateThumbnailPage />} />
          )}

          {/* Fallback */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
